import Warehouse from './WarehouseData';

export default Warehouse;
